

























































































































import Vue from 'vue'
import moment from 'moment'
import { getMobileTheme } from '@/helper'
import { getUserId } from '@/services'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'
import UserAvatar from '@/components/common/UserAvatar.vue'
import { userAvatarImage } from '@/helper/constants'
import { Dropdown, DropdownMenu, DropdownItem } from 'view-design'

export default Vue.extend({
  props: {
    comment: {
      type: Object,
      default: new Object()
    },
    isReply: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    },
    instructor: {
      type: Object
    },
    visibility: {
      type: String,
      default: 'instructorOnly'
    }
  },
  components: {
    UserAvatar,
    BaseIcon,
    Dropdown,
    DropdownMenu,
    DropdownItem
  },
  data() {
    return {
      emptyAvatar: userAvatarImage,
      replyTo: null
    }
  },
  computed: {
    currentUserId() {
      return getUserId()
    },
    repliedToComment() {
      return this.comment.content
    },
    repliedToUserId() {
      return this.comment.userId
    },
    replyToThisUser() {
      return this.comment.userdetails
        ? this.comment.userdetails
        : { name: 'Instructor', id: null }
    },
    commentAvatar() {
      return this.comment.userdetails && this.comment.userdetails.avatar
        ? this.comment.userdetails.avatar
        : this.instructor && this.instructor.headshot
        ? this.instructor.headshot
        : this.emptyAvatar
    },
    userName() {
      return this.comment.userdetails && this.comment.userdetails.name
        ? this.comment.userdetails.name
        : this.instructor && this.instructor.name
        ? this.instructor.name
        : 'Instructor'
    },
    isInstructor() {
      return this.comment.userdetails ? false : true
    },
    isParentComment() {
      return !this.comment.parentCommentId
    }
  },
  methods: {
    commentCreatedAt(time) {
      return moment(time).fromNow()
    },
    triggerReply(userDetails) {
      this.$emit('updateReplyToUser', userDetails)
    },
    deleteComment(commentId) {
      this.$emit('deleteComment', commentId)
    },
    updateEditComment(commentData) {
      this.$emit('updateEditComment', commentData)
    },
    getMobileTheme
  }
})
